import { Routes } from '@angular/router';
import { baseAuthenticatedRoute, baseRoutes } from './routes/baseRoutes';

export const routes: Routes = [...baseRoutes, baseAuthenticatedRoute];
